import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";

import CandidateTable from "./Candidatetable/CandidateTable";
import CandidateReportTable from "./candidateReport/CandidateReport";
import { useEffect, useState } from "react";
import { Pagination } from "antd";

const CandidateListProfile = ({ count, filterValues, filterActive, page, data, getCandidatelistData, getCandidatelistDataFilter }) => {
  // const [count, setCount] = useState([])
  // const [count1, setCount1] = useState(1)
  // useEffect(() => {
  //   if (data?.totalPages) {
  //     const arrr = []
  //     for (let i = 0; i < data.totalPages; i++) {
  //       arrr.push(i + 1)
  //     }
  //     setCount(arrr);
  //   }
  // }, [data])

  // const getCandidatelistData3 = (num) => {
  //   getCandidatelistData2(num)
  //   setCount1(num)
  // }
  const onChangeVal = (pg) => {
    if (filterActive) {
      getCandidatelistDataFilter(filterValues, pg);
    } else {
      getCandidatelistData(pg);
    }
  };
  return (
    <>

      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Candidate List</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/add-candidate" className="btn btn-success">
              <AiOutlinePlus /> Add New Candidate
            </Link>
          </div>
        </div>
      </div>
      <div className="report_table mb-5">
        <CandidateReportTable dataExcel={data} getCandidatelistDataFilter={getCandidatelistDataFilter} getCandidatelistData={getCandidatelistData} />
      </div>
      <div className="pageTableWrapper">
        <div className="pageBody">
          <CandidateTable
            data={data?.data}
            count={count}
            getCandidatelistData={getCandidatelistData}
          />
        </div>
      </div>


      <div className="pageFooter">
        <div className="row">
          <div className="col-md-6">
            <div className="showEntry">
              <p>
                Showing {data?.totalCandidate} entries page
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="text-center">
              <Pagination
                // current={page}
                // pageSize={count}
                onChange={onChangeVal}
                total={data?.totalCandidate || 0}
              />
              {/* <nav aria-label="Page navigation example" style={{ width: "400px", overflow: "auto", margin: "auto" }}>
                  <ul className="pagination" style={{ margin: "18px" }}>
                    {count && count?.map((val) => {
                      return <li className="page-item" onClick={() => { getCandidatelistData3(val) }}><a className="page-link" href="#">{val}</a></li>
                    })}
                  </ul>
                </nav> */}

            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default CandidateListProfile;
